module.exports = __webpack_public_path__ + "img/skeleton-loader-dash--light.099d3873.svg";